/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { CriterionSchema } from './criterionSchema';
import type { SessionSchemaStatus } from './sessionSchemaStatus';

export interface SessionSchema {
  id: string;
  scope: 'job_stage';
  search_id?: string | null;
  job_id?: string | null;
  stage_id?: string | null;
  status: SessionSchemaStatus;
  is_stale: boolean;
  targets_total: number;
  targets_completed: number;
  max_targets: number;
  created_at: string;
  updated_at: string;
  criteria: CriterionSchema[];
}
